import { memo } from 'react'

import { Body2, Chip, Stack, Tooltip } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { renameContentForTenant } from '@tabeeb/modules/contentReviews/actions'
import {
  getCanRenameContentDescriptionForTenant,
  getContentDescriptionForTenant,
  getSelectedTenant,
} from '@tabeeb/modules/sessionsPage/selectors/contentSharings'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'

interface RenameContentButtonProps {
  contentSharingType: ContentSharingModelType
}

const RenameContentButton: React.FC<RenameContentButtonProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const selectedTenant = useSelector((state) => getSelectedTenant(state, { contentSharingType }))
  const isRenameButtonVisible = useSelector((state) =>
    getCanRenameContentDescriptionForTenant(state, { tenantId: selectedTenant?.Id })
  )
  const description = useSelector((state) => getContentDescriptionForTenant(state, { tenantId: selectedTenant?.Id }))
  const isReview = contentSharingType === ContentSharingModelType.ForReview

  if (!isReview) {
    return null
  }

  if (!selectedTenant?.Id) {
    return null
  }

  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Tooltip text={description}>
        <Body2 noWrap>Content Name: {description}</Body2>
      </Tooltip>
      {isRenameButtonVisible && (
        <Chip
          size='small'
          label='Rename'
          color='primary'
          onClick={() => dispatch(renameContentForTenant(selectedTenant.Id))}
        />
      )}
    </Stack>
  )
}

export default memo(RenameContentButton)

